import ReactDOM from 'react-dom/client'
import App from './App'
import { whichAEMComponentToServe } from '@utils/aem'
import {
  AccountStatus,
  FinSimpleContext,
  generateLogger,
  LoggingServiceProvider,
  PlatformName,
  RegistrationStatus,
  setFinSimpleContext,
} from '@fcsmc/react-loading-components'
import { MockedProvider } from '@apollo/client/testing'
import { SnackbarProvider } from '@ucl/react-library/snackbar'
import { Mode, ThemeName, ThemeProvider } from '@ucl/shared-component-foundations'
import { QUERY_MOCKS } from '@mocks/testMocks'
import { ErrorBoundary } from 'react-error-boundary'
import { Suspense } from 'react'
import { teamName } from '@utils/ucl'
import { AccountProvider } from '@src/AccountContext'
import { CustomerProvider } from '@src/CustomerContext'

const div = document.getElementById('root')
const root = ReactDOM.createRoot(div as HTMLElement)

const { element: aemComponent } = whichAEMComponentToServe()

export const mockFsContext: FinSimpleContext = {
  user: {
    userId: '9999-99-999-9999',
    mcn: 9999999,
  },
  api: {
    headers: {
      'Experience-Id': 'FORD-PRO-US',
    },
    urls: {
      base: 'fakeBaseUrl.com',
      log: '/fake-log-service/log',
      query: '/fake-ccn/query',
      profile: '/fake-ccn/profile',
      document: '/fake-ccn/media',
    },
  },
  platform: {
    name: PlatformName.FPG,
    page: 'test-page',
    country: 'us',
    language: 'en',
  },
  session: {
    traceId: '1111-11-111-1111',
    timeStamp: null,
    registrationStatus: RegistrationStatus.COMPLETE,
    eligibility: {
      status: AccountStatus.GOOD_STANDING,
    },
  },
}

setFinSimpleContext(mockFsContext)

const app = () => {
  return <App />
}

root.render(
  aemComponent ? (
    <MockedProvider mocks={QUERY_MOCKS}>
      <ThemeProvider themeName={ThemeName.FORD_PRO} mode={Mode.LIGHT_MODE} productTeamName={teamName}>
        <SnackbarProvider>
          <ErrorBoundary fallback={<p>AEM Error Boundary</p>}>
            <Suspense fallback={<p>Loading...</p>}>
              <LoggingServiceProvider logger={generateLogger(() => {})}>
                <AccountProvider>
                  <CustomerProvider>{aemComponent}</CustomerProvider>
                </AccountProvider>
              </LoggingServiceProvider>
            </Suspense>
          </ErrorBoundary>
        </SnackbarProvider>
      </ThemeProvider>
    </MockedProvider>
  ) : (
    app()
  )
)
